import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";
import ContentErrors from "@/react/story/components/ContentErrors";
import { useErrors } from "@/react/story/providers/ErrorsContext";
import { useLocales } from "@/react/story/providers/LocalesContext";
import type { Locale } from "@/react/story/types";
import TranslationUtils from "@/react/story/utils/TranslationUtils";
import { type FormEvent, useId, useState } from "react";
import { ReactSortable } from "react-sortablejs";

export default function NavLocales() {
    const Locales = useLocales();
    const Errors = useErrors();

    const [ newLocale, setNewLocale ] = useState<Locale | null>(null);
    const id = useId();

    const handleSave = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (newLocale) {
            await Locales.add(newLocale);
            Locales.goto(newLocale);
            setNewLocale(null);
        }
    };

    const handleDelete = async () => {
        if (window.confirm("Voulez-vous vraiment supprimer cette langue ?")) {
            await Locales.remove(Locales.current);
            Locales.goto(undefined);
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                <h2 className="mb-0">Langues</h2>
                {null === newLocale ? (
                    <BootstrapTooltip title="Ajouter">
                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setNewLocale("")}>
                            <span className="bi-plus"></span>
                        </button>
                    </BootstrapTooltip>
                ) : null}
            </div>
            {null === newLocale ? (
                <>
                    {/* @ts-expect-error react-sortablejs types incompatible with React 18 */}
                    <ReactSortable list={Locales.all} setList={list => Locales.set(list)} className="list-group mb-3">
                        {Locales.all.map(((l, i) => (
                            <button
                                type="button"
                                key={l}
                                className={`d-flex align-items-center gap-3 list-group-item list-group-item-action ${l === Locales.current ? "active" : ""}`}
                                onClick={() => Locales.goto(l)}
                            >
                                <span className="text-capitalize me-auto">{TranslationUtils.getLocaleName(l)}</span>
                                <ContentErrors errors={Errors.inLocale(l)} />
                                {0 === i ? (
                                    <BootstrapTooltip title="Langue par défaut">
                                        <span className="bi-star-fill text-warning fw-bolder"></span>
                                    </BootstrapTooltip>
                                ) : null}
                                <span className="bi-grip-vertical cursor-grab ms-3"></span>
                            </button>
                        )))}
                    </ReactSortable>
                </>
            ) : (
                <form onSubmit={handleSave} className="d-flex flex-column gap-3 mb-3">
                    <div>
                        <label htmlFor={id}>Langue</label>
                        <select
                            id={id}
                            className="form-select"
                            onChange={e => setNewLocale(e.target.value)}
                        >
                            <option value="">Choisir une langue</option>
                            {TranslationUtils.getFixedLocales(Locales.presets).map(l => (
                                <option key={l} value={l} disabled={Locales.all.includes(l)} className="text-capitalize">
                                    {TranslationUtils.getLocaleName(l)} [{l}]
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="d-flex justify-content-between gap-3">
                        <button type="button" className="btn btn-outline-secondary" onClick={() => setNewLocale(null)}>
                            Annuler
                        </button>
                        <button className="btn btn-outline-success">
                            Ajouter
                        </button>
                    </div>
                </form>
            )}
            {null === newLocale && 1 < Locales.all.length ? (
                <div className="d-flex justify-content-end mb-3">
                    <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={handleDelete}
                    >
                        Supprimer {TranslationUtils.getLocaleName(Locales.current)}
                    </button>
                </div>
            ) : null}
        </>
    );
}
